
const ENVIRONMENT = {
   PRODUCTION: 'production',
   TEST: 'test',
   DEVELOPMENT: 'development',
}

const GENDER = {
	MALE: 'male',
	FEMALE: 'female',
};

const USER_ROLE = {
   SUPER_ADMIN: 'super-admin',
   ADMIN: 'admin',
   SALES_MANAGER: 'sales-manager',
   TECHNICAL_MANAGER: 'technical-manager',
   FINANCE_MANAGER: 'finance-manager',
   CREDIT_MANAGER: 'credit-manager',
   GUEST: 'guest',
}

const LOAN_STATUS = {
   PENDING: 'pending',
   REJECTED: 'rejected',
   APPROVED: 'approved',
   ACTIVE: 'active',
   COMPLETED: 'completed',
   DEFAULTED: 'defaulted',
}

const DEPARTMENT = {
   FINANCE: 'finance',
   SALES: 'sales',
   TECHNICAL: 'technical',
   CREDIT: 'credit'
}

const CASH_REQUISITION_STATUS = {
   PENDING: 'pending',
   REJECTED: 'rejected',
   APPROVED: 'approved'
}

const AGENT_TYPE = {
   SALES: 'sales',
   TECHNICAL: 'technical'
}

const INSTALLATION_STATUS = {
   PENDING: 'pending',
   IN_PROGRESS: 'in-progress',
   INSTALLED: 'installed',
   REPOSSESSED: 'repossessed'
}

const PAYMENT_TYPE = {
   ONLINE: 'online',
   CASH: 'cash',
   BANK_TRANSFER: 'bank-transfer',
}

const DELIVERY_STATUS = {
   PENDING: 'pending',
   IN_TRANSIT: 'in-transit',
   DELIVERED: 'delivered',
   REPOSSESSED: 'repossessed'
}

const DOCUMENT_NAME = {
   AGENT: {
      CONTRACT: 'Contract',
   },
   CASH_REQUISITION: {
      QUOTATION: 'Quotation',
      PROOF_OF_DISBURSEMENT: 'Proof of Disbursement',
      RECEIPT: 'Receipt',
   },
   CUSTOMER: {
      IDENTITY_DOCUMENT: 'Identity Document',
      PROOF_OF_RESIDENCE: 'Proof of Residence'
   },
   DELIVERY: {
      DELIVERY_NOTE: 'Delivery Note',
   },
   INSTALLATION: {
      COMMISSIONING_DOCUMENT: 'Commissioning Document',
      DELIVERY_NOTE: 'Delivery Note',
   },
   LOAN: {
      BANK_STATEMENT: 'Bank Statement',
      PAYSLIP: 'Payslip',
      FINANCING_QUOTE: 'Financing Quote',
      CONTRACT: 'Contract',
   },
}

const NATIONAL_ID_REGEX = /^\d{2}-\d{4,7}[A-Z]-\d{2}$/

const NOTIFICATION_TYPE = {
   CASH_REQUISITION: 'cash-requisition',
   DELIVERY: 'delivery',
   INSTALLATION: 'installation',
   LOAN: 'loan',
   TOKEN: 'token',
}

const PRODUCT_TYPE = {
   RESIDENTIAL: 'residential',
   COMMERCIAL: 'commercial',
   DC: 'dc',
}

module.exports = {
   AGENT_TYPE,
   CASH_REQUISITION_STATUS,
   DELIVERY_STATUS,
   DEPARTMENT,
   DOCUMENT_NAME,
   ENVIRONMENT,
   GENDER,
   INSTALLATION_STATUS,
   LOAN_STATUS,
   NATIONAL_ID_REGEX,
   NOTIFICATION_TYPE,
   PAYMENT_TYPE,
   PRODUCT_TYPE,
   USER_ROLE
}